import { Component } from '@angular/core';

@Component({
    selector: 'shig-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    protected currentYear = new Date().getFullYear();

    protected openLink(link: string): void {
        window.open(link, '_blank');
    }
}
